@if (breadcrumbs && breadcrumbs.length) {
<div
  class="flex items-center justify-end pb-[2rem] overflow-x-auto whitespace-nowrap"
>
  <div class="flex items-center text-gray-400 -px-2 font-medium">
    @for (breadcrumb of breadcrumbs; track $index;let first = $first, last =
    $last) {
    <span
      [class.underline]="!last"
      [ngClass]="!last ? 'color-primary' : ''"
      [style.color.primary-waste]="!last"
      [class.cursor-pointer]="!last"
      [routerLink]="breadcrumb.route"
    >
      {{ breadcrumb.name }}
    </span>
    @if($index < breadcrumbs.length - 1) {
    <span class="text-gray-400 rtl:-scale-x-100">
      <!-- Add your separator icon or text here -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        />
      </svg>
    </span>
    } }
  </div>
</div>
}
